// Module
var code = "<h3 class=\"m-0 text-sm\"><strong>Date Range of Station Last Changes</strong></h3>\n<span class=\"text-sm m-0\">\n  These dates indicate the first and most recent changes recorded in the selected stations list, showing the range from\n  the earliest to the latest modification date among these stations\n</span>\n";
// Exports
export default code;